exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3wlxhmUlmXi9Q1RnfLHoTr{max-width:800px!important;max-height:700px!important}._28lIhYDFNowPRFrGLe3ft0{display:inline-block}._3v2pLBxkUi9T9RU3umv5yr{width:600px}.nW1_jWU4X2f9nHZkMHtTI{width:400px}", ""]);

// exports
exports.locals = {
	"dialog": "_3wlxhmUlmXi9Q1RnfLHoTr",
	"spinner": "_28lIhYDFNowPRFrGLe3ft0",
	"options": "_3v2pLBxkUi9T9RU3umv5yr",
	"textbox": "nW1_jWU4X2f9nHZkMHtTI"
};